// extracted by mini-css-extract-plugin
export default {"notFoundMainContainer":"NotFound_notFoundMainContainer__zztwB"};